import {emptyPAE, PAE} from './visita-vo';

export interface ResumoPoiVo {
  ordem: number;
  codigo: string;
  horaChegada: PAE<string>;
  horaSaida: PAE<string>;
  chegada?: string;
  saida?: string;
  codigoCliente: string;
  razaoSocial?: string;
  status: string;
  tipo: string;
  servicos: {codigo: string, notaFiscal?: string, tipo: string}[];
  adicionado?: boolean;
  removido?: boolean;
  cancelado?: boolean;
  descricao?: string;
  tipoOrigem?: string;
  incidente?:string;
  iconStatus: string;
  icon: {
    iconID: number;
    textID: number;
  };
}

export const emptyResumoPoi = (): ResumoPoiVo => ({
  codigo: '',
  codigoCliente: '',
  horaChegada: emptyPAE(),
  horaSaida: emptyPAE(),
  icon: {iconID: 0, textID: 0},
  iconStatus: '',
  ordem: 0,
  razaoSocial: '',
  status: '',
  tipo: '',
  servicos: [],
});
